import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import PhaseProgress from "../PhaseProgress";
import "./Spinner.css";

const GENERIC_PHASES = [
  'Processing your request...',
  'Generating content...',
  'Almost there...',
];

export default function Spinner() {
  const { promiseInProgress } = usePromiseTracker();

  if (!promiseInProgress) return null;

  return (
    <div className="spinner-overlay">
      <div className="spinner-panel">
        <PhaseProgress
          phases={GENERIC_PHASES}
          isActive={promiseInProgress}
          variant="panel"
        />
      </div>
    </div>
  );
}
